export const projects = [
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/image_notifproject.png',
    title: 'no•tif',
    status: 'In progress',
    href: 'https://main.d2uxrrz05dtxm4.amplifyapp.com/',
    links: {
      Github: 'https://github.com/tran28/notif-project',
      Figma:
        'https://www.figma.com/file/ynjeCPct7udkLBg1YJBxmu/NotifProject?type=design&node-id=0-1&mode=design',
    },
    description: 'Automated SMS notifications for product discounts.',
    technologies: ['Figma', 'React', 'Amplify', 'API Gateway', 'Lambda', 'DynamoDB', 'SNS', 'OpenAI', 'Python', 'Tailwind'],
  },
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/image_nicehairsalon.png',
    title: 'Nice Hair Salon',
    status: 'Freelance',
    href: 'https://nicehairsalon.ca/',
    links: { Github: 'https://github.com/tran28/nice-hair-salon' },
    description: 'Storefront landing page, designed and built end-to-end.',
    technologies: ['Next.js', 'Tailwind', 'TypeScript'],
  },
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/image_speedymart.png',
    title: 'SpeedyMart',
    status: 'Course final',
    href: 'https://speedymart.herokuapp.com/',
    links: {
      Github: 'https://github.com/tran28/SpeedyMart',
      PDF: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/pdf_speedymart.pdf',
    },
    description: 'Convenience-store e-commerce site, built for a final.',
    technologies: ['React', 'Express', 'MongoDB', 'AWS S3', 'Heroku', 'Jest'],
  },
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/image_aim.png',
    title: 'AiM',
    status: 'Engineering capstone',
    href: 'https://www.youtube.com/watch?v=7gM-D7A--6E',
    links: {
      Github: 'https://github.com/tran28/AI_Learning_Platform-AiM',
      Youtube: 'https://www.youtube.com/watch?v=7gM-D7A--6E',
      PDF: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/pdf_eng4000_final_report_aim.pdf',
    },
    description: 'Cloud-based AI e-learning tool studying gender bias in teaching.',
    technologies: ['React', 'Express', 'MySQL', 'GCP Natural Language'],
  },
  {
    image: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/VideoCoSystem.png',
    title: 'VideoCoSystem',
    status: 'Software design course',
    href: 'https://www.youtube.com/watch?v=HsA7-JrNYWM',
    links: {
      Github: 'https://github.com/tran28/EECS3311_FinalProject',
      Youtube: 'https://www.youtube.com/watch?v=HsA7-JrNYWM',
      UML: 'https://matthew-tran-portfolio.s3.us-east-2.amazonaws.com/VideoCoSystem_UML.png',
    },
    description: 'Movie-ordering system. Design by contract, OOP patterns.',
    technologies: ['Java', 'Gradle', 'JavaFX', 'UML'],
  },
];
